export default {
 home_title:'01Web-智门户首页',
 home_change_mune:'0108Web-切换菜单',
 home_more_learn_footprint:'查看更多學習足跡',
 home_more:'0112Web-首页-查看更多',
 home_see_learn_tasks:'0109Web-查看学习任务项',
 home_click_banner:'0110Web-点击Banner',
 home_Team_management:'團隊學習管理',
 home_click_content:'0111Web-首页-点击内容'
}
